/**
 * Адаптеры хранения JWT.
 *
 * Обычный login-флоу → localStorage по ключу `access_token`.
 * Флоу приглашения менеджера → HTTP-cookie (совместимость с manager-web).
 *
 * Скопировано из manager-web без изменений — единый контракт хранения
 * токена между приложениями (Спринт 7: tenant-app консолидирует apps).
 */

export const ACCESS_TOKEN_KEY = 'access_token';
export const REFRESH_TOKEN_KEY = 'refresh_token';

/** Читает JWT из localStorage (обычный login). */
export function readLocalAccessToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(ACCESS_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function writeLocalAccessToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(ACCESS_TOKEN_KEY, token);
  } catch {
    // игнорируем ошибки хранилища (приватный режим, квота)
  }
}

export function writeLocalRefreshToken(token: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(REFRESH_TOKEN_KEY, token);
  } catch {
    // игнорируем
  }
}

export function readLocalRefreshToken(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage.getItem(REFRESH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function clearLocalTokens(): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(ACCESS_TOKEN_KEY);
    window.localStorage.removeItem(REFRESH_TOKEN_KEY);
  } catch {
    // игнорируем
  }
}

/** Читает cookie `access_token` (флоу приглашения). */
export function readAccessTokenCookie(): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie
    .split(';')
    .map((c) => c.trim())
    .find((c) => c.startsWith(`${ACCESS_TOKEN_KEY}=`));
  if (!match) return null;
  return decodeURIComponent(match.slice(ACCESS_TOKEN_KEY.length + 1));
}
